import { render } from "./AutoTopupActivationMPayLandingSuccess.vue?vue&type=template&id=423f866e&scoped=true"
import script from "./AutoTopupActivationMPayLandingSuccess.vue?vue&type=script&lang=js"
export * from "./AutoTopupActivationMPayLandingSuccess.vue?vue&type=script&lang=js"

import "./AutoTopupActivationMPayLandingSuccess.vue?vue&type=style&index=0&id=423f866e&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423f866e"]])

export default __exports__